import React from "react";
import { Link } from "react-router-dom";

const COLS = [
    {
        title: "SHOP",
        links: [
            ["New Arrivals", "/shop"],
            ["Women", "/shop?department=Women"],
            ["Kids", "/shop?department=Kids"],
            ["T-Shirts", "/shop?category=T-Shirts"],
            ["Hoodies", "/shop?category=Hoodies"],
            ["Jackets", "/shop?category=Jackets"],
            ["Bottoms", "/shop?category=Bottoms"],
            ["Accessories", "/shop?category=Accessories"],
        ],
    },
    {
        title: "ABOUT",
        links: [
            ["Our Story", "/#manifesto"],
            ["Collections", "/#collections"],
            ["Contact", "/#newsletter"],
        ],
    },
    {
        title: "SUPPORT",
        links: [
            ["Shipping", "/#"],
            ["Returns", "/#"],
            ["Size Guide", "/#"],
            ["FAQ", "/#"],
        ],
    },
    {
        title: "SOCIAL",
        links: [
            ["Instagram", "/#"],
            ["TikTok", "/#"],
            ["YouTube", "/#"],
        ],
    },
];

export default function Footer() {
    return (
        <footer data-testid="site-footer" className="relative overflow-hidden border-t border-[rgba(10,10,10,0.12)] bg-[#F2F0EA]">
            <div className="mx-auto grid max-w-7xl grid-cols-2 gap-12 px-6 py-20 sm:px-8 md:grid-cols-5 lg:px-16">
                <div className="col-span-2 md:col-span-1">
                    <p className="font-display text-sm font-extrabold uppercase leading-tight tracking-[0.3em]">
                        Vantage
                        <span className="block text-[8px] font-medium tracking-[0.5em] text-[#8E8D8A]">Owners Club</span>
                    </p>
                    <p className="mt-6 max-w-[200px] text-xs leading-relaxed text-[#6B6A66]">
                        Premium streetwear built around transformation, movement and perspective.
                    </p>
                </div>
                {COLS.map((col) => (
                    <div key={col.title}>
                        <p className="mb-5 text-[9px] uppercase tracking-[0.35em] text-[#6B6A66]">{col.title}</p>
                        <ul className="space-y-3">
                            {col.links.map(([label, to]) => (
                                <li key={label}>
                                    <Link
                                        data-testid={`footer-link-${label.toLowerCase().replace(/\s+/g, "-")}`}
                                        to={to}
                                        className="link-underline text-xs uppercase tracking-[0.15em] text-[#8E8D8A] transition-colors hover:text-[#0A0A0A]"
                                    >
                                        {label}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>
                ))}
            </div>
            <div className="relative h-[18vw] overflow-hidden" aria-hidden="true">
                <p className="font-display absolute inset-x-0 top-0 select-none text-center text-[24vw] font-black uppercase leading-[0.8] tracking-tighter text-[#0A0A0A] opacity-[0.05]">
                    Vantage
                </p>
            </div>
            <div className="flex flex-col items-center justify-between gap-3 border-t border-[rgba(10,10,10,0.08)] px-6 py-6 sm:flex-row sm:px-8 lg:px-16">
                <p className="text-[9px] uppercase tracking-[0.35em] text-[#6B6A66]">© 2026 Vantage Owners Club</p>
                <p className="text-[9px] uppercase tracking-[0.35em] text-[#6B6A66]">Canada</p>
            </div>
        </footer>
    );
}
